module.exports = __webpack_public_path__ + "static/10-COREA-SOJU.e15f7b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/10-COREA-SOJU.png
// module id = 604
// module chunks = 35783957827783